import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Button from 'Common/CustomButtons/Button';
import { ContactInfoForm, ProfessionalInfoForm, IdsInfoForm } from 'Components/FormGroup';

export default class CoAuthorForm extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        removeCoauthor: PropTypes.func.isRequired,
        number: PropTypes.number,
    };

    render() {
        const { removeCoauthor, number } = this.props;

        return (
            <div className="coauthor-form-wrapper">
                <Button
                    color="danger"
                    type="button"
                    onClick={() => removeCoauthor(number)}
                    className="button-remove-coauthor"
                >
                    <FormattedMessage id={'button.submission.remove_coauthor'} />
                </Button>

                <ContactInfoForm title="form_groups.coauthor_info" required namePrefix={`coauthors[${number}].`} />

                <ProfessionalInfoForm
                    title="form_groups.coauthor_professional"
                    namePrefix={`coauthors[${number}].`}
                    exclude={['interests']}
                />

                <IdsInfoForm title="form_groups.ids_info" namePrefix={`coauthors[${number}].`} exclude={['orcid_link']}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Submission/CoAuthorForm.jsx